import React, { useState } from "react";
import LiveClock from "react-live-clock";
import { useSelector } from "react-redux";
import { myradioApiRequest } from "../api";
import { useInterval } from "../lib/utils";
import { RootState } from "../rootReducer";
import "./timelord.scss";
import logo from "../assets/images/navbarlogo.png";

const SILENCE_WARN_SECS = 5;

export function Timelord() {
  async function getSource() {
    if (process.env.REACT_APP_BAPSICLE_INTERFACE)
      return { id: -1, name: "Unknown" };
    let studio = await myradioApiRequest("/selector/studioattime", "GET", null);
    const sourceNames = [
      "Studio Red",
      "Studio Blue",
      "Jukebox",
      "OB",
      "WebStudio",
      "Unknown",
      "Sine Wave",
      "Station is Off Air",
    ];

    let sourceName = "Unknown";
    if (studio > 0 && studio <= sourceNames.length) {
      sourceName = sourceNames[studio - 1];
    }

    return { id: studio, name: sourceName };
  }

  async function getSilence() {
    if (process.env.REACT_APP_BAPSICLE_INTERFACE) return false;
    let silence = await myradioApiRequest("/selector/issilence", "GET", null);

    return silence >= SILENCE_WARN_SECS;
  }

  const broadcastStage = useSelector(
    (state: RootState) => state.broadcast.stage
  );
  const broadcastConnection = useSelector(
    (state: RootState) => state.broadcast.connectionState
  );
  const [source, setSource] = useState({ id: -1, name: "Loading" });
  const [isSilence, setSilence] = useState(false);

  useInterval(
    async () => {
      setSource(await getSource());
    },
    broadcastStage === "REGISTERED" ? 3000 : 10000
  );

  useInterval(async () => {
    broadcastStage === "REGISTERED"
      ? setSilence(await getSilence())
      : setSilence(false);
  }, 3000);

  return (
    <li
      className="btn rounded-0 py-2 nav-link nav-item"
      id="timelord"
      onClick={(e) => {
        e.preventDefault();
        window.open(
          "http://ury.org.uk/timelord/",
          "URY - Timelord",
          "resizable,status"
        );
      }}
    >
      {process.env.REACT_APP_BAPSICLE_INTERFACE && (
        <img src={logo} className="mr-2" height={32} alt="Logo" />
      )}

      <LiveClock
        format={"HH:mm:ss"}
        ticking={true}
        timezone={"europe/london"}
      />
      {broadcastStage === "REGISTERED" &&
      ["LIVE", "CONNECTED"].indexOf(broadcastConnection) === -1 ? (
        <span className="error">Streaming Error!</span>
      ) : isSilence ? (
        <span className="error">SILENCE DETECTED</span>
      ) : (
        source.id > -1 && (
          <span className="source">
            <span className={"studio studio" + source.id}>{source.name}</span>
            {source.id !== 8 ? " is On Air" : ""}
          </span>
        )
      )}
    </li>
  );
}
